import { Shirt, ClipboardList, Hammer, PackageOpen, Wrench, Briefcase, Phone, Image as ImageIcon, FileText, Lock } from "lucide-react";
import { useLang } from "@/lib/i18n";

const Block = ({ icon: Icon, title, children, testid }) => (
  <div className="py-4 border-b border-black/[0.06] last:border-0" data-testid={testid}>
    <div className="flex items-center gap-2 eyebrow mb-2">
      <Icon className="w-3.5 h-3.5 text-[#C5A059]" strokeWidth={1.5} />
      {title}
    </div>
    <div className="text-sm text-neutral-700 leading-relaxed whitespace-pre-line">{children}</div>
  </div>
);

export const EventInfo = ({ event, showInternal = false }) => {
  const { t } = useLang();
  const rows = [
    ["description", FileText, "i.description"],
    ["dress_code", Shirt, "i.dress"],
    ["instructions", ClipboardList, "i.ops"],
    ["setup_instructions", Hammer, "i.setup"],
    ["teardown_instructions", PackageOpen, "i.teardown"],
    ["equipment", Wrench, "i.equipment"],
    ["client_instructions", Briefcase, "i.client"],
  ];
  return (
    <div data-testid="event-info">
      {rows.map(([k, Icon, label]) => event[k] ? <Block key={k} icon={Icon} title={t(label)} testid={`event-info-${k}`}>{event[k]}</Block> : null)}
      {(event.supervisor_name || event.supervisor_phone) && (
        <Block icon={Phone} title={t("i.supervisor")} testid="event-info-supervisor">
          {event.supervisor_name}
          {event.supervisor_phone && (
            <a href={`tel:${event.supervisor_phone}`} className="ml-2 text-[#8a6d2f] underline underline-offset-2">{event.supervisor_phone}</a>
          )}
        </Block>
      )}
      {event.attachments?.length > 0 && (
        <Block icon={ImageIcon} title={t("i.files")} testid="event-info-attachments">
          <div className="flex flex-wrap gap-2">
            {event.attachments.map((a, i) => (
              <a key={i} href={a.url} target="_blank" rel="noreferrer" className="press border border-black/10 px-3 py-1.5 text-xs hover:border-[#C5A059]">
                {a.label || a.url}
              </a>
            ))}
          </div>
        </Block>
      )}
      {showInternal && event.internal_notes && (
        <div className="dark-zone mt-4 p-4 rounded-xl bg-black/60 border border-[#C5A059]/25 text-white" data-testid="event-info-internal">
          <div className="flex items-center gap-2 text-[11px] uppercase tracking-[0.2em] text-[#C5A059] mb-2">
            <Lock className="w-3.5 h-3.5" /> {t("i.internal")}
          </div>
          <p className="text-sm text-white/80 whitespace-pre-line">{event.internal_notes}</p>
        </div>
      )}
    </div>
  );
};
